import "@styles/about.sass"
import Swiper, {Controller, EffectFade, Pagination} from "swiper";

(() => {
    const wrapperEl = document.querySelector("[data-about-phases]") as HTMLElement,
        sections = Array.from(wrapperEl?.querySelectorAll("section") ?? []) as HTMLElement[]

    sections.forEach(section => {
        const photoSwiperEl = section.querySelector("[data-phase-photos]") as HTMLElement,
            contentSwiperEl = section.querySelector("[data-phase-content]") as HTMLElement

        if (!photoSwiperEl || !contentSwiperEl) return

        if (window.innerWidth < 1024) {
            const photoSwiper = new Swiper(photoSwiperEl, {
                slidesPerView: 'auto',
                spaceBetween: 8,
                modules: [ Controller ]
            })

            const contentSwiper = new Swiper(contentSwiperEl, {
                slidesPerView: 1,
                autoHeight: true,
                modules: [ Controller, Pagination ],
                pagination: {
                    el: '[data-phase-pagination]',
                    type: 'bullets'
                },
            })

            photoSwiper.controller.control = contentSwiper
            contentSwiper.controller.control = photoSwiper
        } else {
            section.photoSwiper = new Swiper(photoSwiperEl, {
                allowTouchMove: false,
                slidesPerView: 1,
                modules: [EffectFade],
                effect: 'fade',
                fadeEffect: {
                    crossFade: true
                },
            })

            section.setProgress = (value: int) => {
                const progress = section.querySelector('svg[data-progress-circle] path') as SVGPathElement;

                progress.getBoundingClientRect()
                progress.style.strokeDashoffset = String(Math.max(0, progress.getTotalLength() * ((100 - value) / 100)))
            }
        }
    })

    if (window.innerWidth < 1024)
        return

    const setActiveStep = () => {
        const sectionSize = wrapperEl.querySelector("[data-phase-spacer]") as HTMLElement,
            scrollProgress = Math.max(((window.scrollY - wrapperEl.offsetTop) / sectionSize.clientHeight), 0),
            activeSection = Math.min(Math.floor(scrollProgress), sections.length - 1)

        sections.forEach(section => {
            const sectionIndex = sections.indexOf(section),
                steps = Array.from(section.querySelectorAll('[data-step]')) as HTMLElement[],
                activeStep = Math.min(Math.floor((Math.min(Math.max(scrollProgress, sectionIndex), sectionIndex + 1) - sectionIndex) * steps.length), steps.length - 1)

            steps.forEach(step => step.classList.toggle('is-active', parseInt(step.dataset.step) === activeStep))
            section.photoSwiper?.slideTo(activeStep)
            section.setProgress((100 / steps.length) * (activeStep + 1))
            section.classList.toggle('is-active', sectionIndex === activeSection)
        })
    }

    window.addEventListener("scroll", setActiveStep)
    setActiveStep()
})();